import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const isAuthenticated = !!localStorage.getItem('accessToken'); // Example: Check if a token exists
    if (!isAuthenticated) {
      this.router.navigate(['/landing-page']); // Redirect to landing page if not authenticated
      return false;
    }
    return true;
  }
}